const TaskNote = React.memo(function TaskNote(props){
    const {
        value,
        showSubject,
        showImportant,
        onChange,
    } = props;

    const change = React.useCallback((name, value) => {
        onChange(name, value);
    }, []);

    //useRenderDebug('TaskNote', {props});

    return (
        <div className={`processes-task-note flex-vertical`}>
            {showSubject &&
                <TaskField
                    type={'text'}
                    label={'Subject'}
                    name={'task_subject'}
                    required={false}
                    placeholder={'Your message subject'}
                    value={value.task_subject || ''}
                    onChange={change}
                />
            }
            <TaskField
                type={'textArea'}
                name={'task_note'}
                label={'Body'}
                placeholder={'Your message body'}
                required={true}
                value={value.task_note || ''}
                rows={10}
                onChange={change}
            />
            {showImportant &&
                <TaskField
                    type={'checkbox'}
                    name={'task_important'}
                    boxLabel={'Mark this note as Important'}
                    required={false}
                    checked={value.task_important || false}
                    onChange={change}
                />
            }
        </div>
    );
});

TaskNote.defaultProps = {
    value: PropTypes.any,
    showSubject: PropTypes.bool,
    showImportant: PropTypes.bool,
    onChange: PropTypes.func,
};

TaskNote.defaultProps = {
    value: {},
    showSubject: false,
    showImportant: false,
    onChange: (path, value) => {},
};
TaskNote.displayName = 'TaskNote';